import {useEffect, useState} from 'react';
import {CampaignProps} from '@/types/campaign';
import campaignPreferredAgeToSearchOptions, {
  campaignCreatorPlatformMetricsToSearchOptions,
  campaignPreferredGenderToSearchOptions,
  campaignPreferredPlatformToSearchOptions,
  campaignPreferredLocationsToSearchOptions,
  combineResults,
  CampaignFiltersStackResult,
} from '@/views/creators/search/utils/campaignValuesToSearchOptions';

const useCreateFiltersStackFromCampaignData = (
  selectedCampaign: CampaignProps | null,
  uniqueSelectActionTrigger: string,
  isLoadingPrefetchedData: boolean
): CampaignFiltersStackResult[] => {
  const [campaignFiltersStack, setCampaignFiltersStack] = useState<
    CampaignFiltersStackResult[]
  >([]);

  useEffect(() => {
    if (!selectedCampaign || isLoadingPrefetchedData) {
      return;
    }
    const {
      preferredCreatorAgeDetail,
      preferredCreatorGenders,
      socialNetwork,
      preferredCreatorCities,
      preferredCreatorStates,
      preferredCreatorCountries,
    } = selectedCampaign;
    const followersOption: CampaignFiltersStackResult =
      campaignCreatorPlatformMetricsToSearchOptions(
        selectedCampaign.unlocksAt,
        selectedCampaign.locksAbove as number | undefined,
        'followers'
      );

    const ageOption: CampaignFiltersStackResult = preferredCreatorAgeDetail
      ? campaignPreferredAgeToSearchOptions(preferredCreatorAgeDetail)
      : null;

    const genderOptions: CampaignFiltersStackResult =
      preferredCreatorGenders && preferredCreatorGenders.length === 1
        ? campaignPreferredGenderToSearchOptions(preferredCreatorGenders)
        : null;

    const platformOption: CampaignFiltersStackResult =
      campaignPreferredPlatformToSearchOptions(
        socialNetwork ? socialNetwork.id : ''
      );

    const fetchLocationAndSetFilters = async () => {
      const locationOption: CampaignFiltersStackResult[] =
        await campaignPreferredLocationsToSearchOptions({
          cities: preferredCreatorCities,
          states: preferredCreatorStates,
          countries: preferredCreatorCountries,
        });

      const filtersStack = combineResults(
        ageOption,
        followersOption,
        genderOptions,
        platformOption,
        locationOption
      );

      setCampaignFiltersStack(filtersStack);
    };

    fetchLocationAndSetFilters();
  }, [selectedCampaign, uniqueSelectActionTrigger, isLoadingPrefetchedData]);

  return selectedCampaign ? campaignFiltersStack : [];
};

export default useCreateFiltersStackFromCampaignData;
